import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {

        showSearchMenu: {
            show: false,
            style: "background-color: #5d6367; color: #cecece"
        },
        reloadPage: false,
        showHeader: true,
        elementToSearchOfGridMenu: [],
        selectedCommercial: { commercialSelected: null, show: false, color: "" },
        divisionAppSelected: null,
        // current selected communication
        communicationSelected: null,
        // current selected communication changed
        communicationSelectedChanged: false,
        // used to update notify mail icon messages number
        communicationsUpdated: false,
        refreshCommunications: false,
        setBreadcrumb: { backurl: "", text: "" }
    },

    mutations: {
        SET_showSearchMenu: (state, payload) => {
            state.showSearchMenu = payload;
        },
        SET_reloadPage: (state, payload) => {
            state.reloadPage = payload;
        },
        SET_showHeader: (state, payload) => {
            state.showHeader = payload;
        },
        SET_elementToSearchOfGridMenu: (state, payload) => {
            state.elementToSearchOfGridMenu = payload;
        },
        SET_selectedCommercial: (state, payload) => {
            state.selectedCommercial = payload;
        },
        SET_divisionAppSelected: (state, payload) => {
            state.divisionAppSelected = payload;
        },
        SET_communicationSelected: (state, payload) => {
            state.communicationSelected = payload;
        },
        SET_communicationSelectedChanged: (state, payload) => {
            state.communicationSelectedChanged = payload;
        },
        SET_communicationsUpdated: (state, payload) => {
            state.communicationsUpdated = payload;
        },
        SET_refreshCommunications: (state, payload) => {
            state.refreshCommunications = payload;
        },
        SET_setBreadcrumb: (state, payload) => {
            state.setBreadcrumb = payload;
        },
    },
    getters: {

        GET_showSearchMenu: state => {
            return state.showSearchMenu;
        },
        GET_reloadPage: state => {
            return state.reloadPage;
        },
        GET_showHeader: state => {
            return state.showHeader;
        },
        GET_elementToSearchOfGridMenu: state => {
            return state.elementToSearchOfGridMenu;
        },
        GET_selectedCommercial: state => {
            return state.selectedCommercial;
        },
        GET_divisionAppSelected: state => {
            return state.divisionAppSelected;
        },
        GET_communicationSelected: state => {
            return state.communicationSelected;
        },
        GET_communicationSelectedChanged: state => {
            return state.communicationSelectedChanged;
        },
        GET_communicationsUpdated: state => {
            return state.communicationsUpdated;
        },
        GET_refreshCommunications: state => {
            return state.refreshCommunications;
        },
        GET_setBreadcrumb: state => {
            return state.setBreadcrumb;
        },
    },
    actions: {

    },
});
